import { Component, OnInit, Input,PLATFORM_ID, Inject, ChangeDetectionStrategy, ViewEncapsulation } from '@angular/core';
import { ComponentRendering } from '@sitecore-jss/sitecore-jss-angular';
import { AccordionBaseComponent } from '../../base-components/accordion-base';
import { ILinkItemDataModel } from '../../models/link-item.datamodel';
import { CustomDeviceDetectorService } from '../../services/custom-device-detector.service';
import { JssContextService } from "../../jss-context.service";
import { Subscription } from "rxjs";
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { EventBasedMarketingService } from '../../services/event-based-marketing.service';
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class FooterComponent extends AccordionBaseComponent implements OnInit {
  @Input() rendering: ComponentRendering;
  // footerColumns: Array<title:string, ILinkItemDataModel[]>=[];
  mainColumns: {title: string, footerItems: ILinkItemDataModel[]}[] = [];
  bottomColumns: {title: string, footerItems: ILinkItemDataModel[]};
  copyrightLabel : string;
  displayAppStore: boolean;
  displayGooglePlay: boolean;
  displayHuawei: boolean;
  
  public contextSubscription: Subscription;

    _isPlatformServer: boolean = false;
    _isPlatformBrowser: boolean = false;

  constructor(private deviceDetector: CustomDeviceDetectorService, 
              @Inject(PLATFORM_ID) public readonly platformId: string,
              public jssContext: JssContextService,
              public eventBasedMarketingService: EventBasedMarketingService
            ) { super(platformId); }

  ngOnInit() {
    super.ngOnInit();
    const fields = this.rendering.fields as any;
    this._isPlatformServer = isPlatformServer(this.platformId);
    this.contextSubscription = this.jssContext.state.subscribe((newState) => {
      this._isPlatformServer = isPlatformServer(this.platformId);
      this._isPlatformBrowser = isPlatformBrowser(this.platformId);
      if(!this._isPlatformServer && this._isPlatformBrowser && newState.sitecore?.route){
          this.eventBasedMarketingService.addFooterScript(this.rendering, newState.sitecore?.route);
      }
    });

    (fields?.FooterColumns as [])?.forEach((footerColumn:any) => {
      var items:ILinkItemDataModel[]=[];

      (footerColumn.fields?.FooterItems as [])?.forEach((footerItem:any) => {
        items.push({
          href: footerItem.fields.Link?.value?.href,
          target: footerItem.fields.Link?.value?.target,
          text: footerItem.fields.Title?.value
        })
      });
      this.mainColumns.push({
        title:footerColumn.fields?.FooterColumnTitle?.value,
        footerItems:items
      })
    });

    this.bottomColumns = {
      title:fields?.FooterBottomColumn[0].fields?.FooterColumnTitle?.value,
      footerItems:[]
    }
    fields?.FooterBottomColumn[0]?.fields?.FooterItems?.forEach((item:any) => {
      this.bottomColumns.footerItems.push({
        href: item.fields.Link?.value?.href,
        target: item.fields.Link?.value?.target,
        text: item.fields.Title?.value
      });
    });

    this.displayAppStore = this.deviceDetector.isDesktopOriOS();
    this.displayGooglePlay = this.deviceDetector.isDesktopOriAndroid();
    this.displayHuawei = this.deviceDetector.isDesktopOriHuawei();
    this.copyrightLabel = fields?.CopyrightLabel?.value;
    this.copyrightLabel = this.copyrightLabel.replace("##year##", new Date().getFullYear().toString());
  }

  trackByFooterItems(item:any): string{
    return item.href;
  }

  trackByMainColumn(item:any): string{
    return item.href;
  }
}
